/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a pie chart from pasted data — show proportions of a whole, no sign-up.`)
};

const es_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico circular a partir de datos pegados — muestra proporciones de un todo, sin registro.`)
};

const de_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Kreisdiagramm aus eingefügten Daten — zeigen Sie Anteile eines Ganzen, keine Anmeldung erforderlich.`)
};

const nl_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een cirkeldiagram van geplakte data — toon aandelen van een geheel, geen registratie nodig.`)
};

const fr_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un diagramme circulaire à partir de données collées — montrez les proportions d'un tout, sans inscription.`)
};

const it_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a torta dai dati incollati — mostra le proporzioni di un totale, senza registrazione.`)
};

const pt_br2_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de pizza a partir de dados colados — mostre proporções de um total, sem cadastro.`)
};

const pt_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico circular a partir de dados colados — mostre proporções de um todo, sem registo.`)
};

const ja_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたデータから円グラフを作成します — 全体に対する割合を表示、登録不要。`)
};

const zh_pie_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据粘贴的数据创建饼图——展示整体中各部分的占比，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_tool_description", locale)
	if (locale === "en") return en_pie_tool_description(inputs)
	if (locale === "es") return es_pie_tool_description(inputs)
	if (locale === "de") return de_pie_tool_description(inputs)
	if (locale === "nl") return nl_pie_tool_description(inputs)
	if (locale === "fr") return fr_pie_tool_description(inputs)
	if (locale === "it") return it_pie_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_pie_tool_description(inputs)
	if (locale === "pt") return pt_pie_tool_description(inputs)
	if (locale === "ja") return ja_pie_tool_description(inputs)
	return zh_pie_tool_description(inputs)
};